import React, { useState, useEffect } from "react";
import { ChevronDown, Maximize2 } from "lucide-react";

function renderLink(url) {
  let domain;
  try {
    domain = new URL(url).hostname.replace(/^www\./, "");
  } catch {
    domain = url;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="source-link"
    >
      <span className="source-symbol">⍈</span>
      <span className="source-domain">{domain}</span>
    </a>
  );
}

export default function CompanyList({ rows = [], expandable = true }) {
  const [openIdx, setOpenIdx] = useState(null);
  const [outerOpen, setOuterOpen] = useState(false);

  // Close the source popout when clicking outside of any action container
  useEffect(() => {
    if (openIdx === null) return;
    const handleClick = e => {
      if (!e.target.closest(".action-container")) {
        setOpenIdx(null);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [openIdx]);

  if (!rows.length) return null;

  const table = (
    <>
    <table className="company-table">
      <thead>
        <tr>
          <th>Company</th>
          <th>Action (Click the action to view sources)</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => {
          const open = openIdx === i;
          const status = (r.monthly_status || "").toLowerCase();
          return (
            <tr key={i}>
              <td>{r.company}</td>
              <td>
                {r.sources && r.sources.length > 0 ? (
                  <div className={`action-container ${status}${open ? " open" : ""}`}>
                    <button
                      className={`action-toggle${open ? " open" : ""}`}
                      onClick={() => setOpenIdx(open ? null : i)}
                    >
                      <span className="action-text">{r.action || "—"}</span>{"\u00A0"}
                      <Maximize2 className="action-open-icon" size={13} />
                    </button>
                    {open && (
                      <div className="statement-box">
                        <div className="statement-text">
                          {r.sources.length > 1 ? "Sources" : "Source"}
                        </div>
                        <div className="statement-sources">
                          {r.sources.map((s, idx) => (
                            <React.Fragment key={idx}>{renderLink(s)}</React.Fragment>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    {r.action || "—"}
                  </>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <div className="table-bottom-bar"></div>
    </>
  );

  if (!expandable) return table;
  return (
    <details
      className="company-expand"
      open={outerOpen}
      onToggle={e => setOuterOpen(e.target.open)}
    >
      <summary className="gold-button browse-btn">
        Browse actions
        <ChevronDown className={`chevron${outerOpen ? " open" : ""}`} size={16} />
      </summary>
      {table}
    </details>
  );
}
